// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"327":"c8f0e346","417":"97873bb9","533":"a3f9b00b"}[chunkId] + ".css";
};